import ValidateFiscalDataError from './ValidateFiscalDataError';
class InvestorDoesNotHaveFiscalRegime extends ValidateFiscalDataError {
    constructor(options) {
        super('Investor has incomplete fiscal data', options);
    }
}
export default InvestorDoesNotHaveFiscalRegime;
